import { ChatRepository } from "../repositories/ChatRepository";

export class ClearChat {
	constructor(private repository: ChatRepository) {}
	execute(chat_id: string): Promise<void> {
		return this.repository.clearChat(chat_id);
	}
}
